













import { Component, Vue } from 'vue-property-decorator'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import ConvertFastqForm from '@/components/convertFastq/ConvertFastqForm.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'

@Component({
  components: {
    ConvertFastqForm,
    ModuleWrapper,
    ModuleIntroduction
  }
})
export default class ConvertFastq extends Vue {
}

